import React from 'react';

import WpIcon from 'Wpds/components/icon/WpIcon';
import { sanitizeFullName } from 'Shared/helpers';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './GoalDropdown.scss';

type Props = {
  readonly goalIcon: string;
  readonly goalName: string;
  readonly goalOwner: string;
};

function GoalDropdown({ goalIcon, goalName, goalOwner }: Props) {
  const { tr } = useTranslation();
  const baseClassName = 'GoalDropdown';
  return (
    <div className={`${baseClassName} d-flex flex-column`}>
      <div className={`${baseClassName}__header d-flex justify-content-between align-items-center p-2`}>
        <div className="d-flex align-items-center flex-nowrap">
          <WpIcon name={goalIcon} />
          <div className="ml-1">{tr('perform.meeting_item.actions_dropdown.goal_dropdown.title')}</div>
        </div>
        <div className={`${baseClassName}__header_owner`}>
          {tr('perform.meeting_item.actions_dropdown.goal_dropdown.owner_with_name', sanitizeFullName(goalOwner))}
        </div>
      </div>
      <div className={`${baseClassName}__content px-2`}>
        <div className={`${baseClassName}__content__name`}>{goalName}</div>
      </div>
    </div>
  );
}

export default GoalDropdown;
